import {
  PermissionAction,
  PermissionResource
} from '../data/workbench-api/generated/types'

// Needs to be in order of power asc
const ACTIONS = [
  PermissionAction.View,
  PermissionAction.Edit,
  PermissionAction.Admin
]
export function requireAction(
  myPermission: PermissionAction,
  requiredPermission: PermissionAction
) {
  return ACTIONS.indexOf(myPermission) >= ACTIONS.indexOf(requiredPermission)
}

export type Permission = {
  resource: PermissionResource
  action: PermissionAction
  environmentId?: string
}

export const hasPermission = (
  myPermissions: Permission[],
  resource: PermissionResource,
  requiredPermission: PermissionAction,
  environmentId?: string
) => {
  return myPermissions.some(
    node =>
      node.resource === resource && // Resource matches
      (node.environmentId // If permission is specific to environment, ensure environment matches
        ? node.environmentId === environmentId
        : true) &&
      node.action && // Ensure that we have at least this level, i.e. Admin grants Editor etc
      requireAction(node.action, requiredPermission)
  )
}
